import RegisterFailedNotification from './RegisterFailedNotification';

export default RegisterFailedNotification;



// WEBPACK FOOTER //
// ./src/components/RegisterFailedNotification/index.js